export default __webpack_public_path__ + "static/media/reglogin-bg-id.ba02b16b.webp";